<template>
    <div>
        <div class="lead">
            <div class="text-center">
                <font-awesome-icon
                    icon="fa-duotone fa-id-card"
                    size="5x"
                    class="text-primary"
                />
            </div>

            <div class="mt-3">
                {{ $t("Upload Photo ID to Continue") }}
            </div>
        </div>

        <div class="mt-3">
            <div v-if="url">
                <b-btn
                    v-if="cordova"
                    @click="cordovaVerification"
                    variant="primary"
                    size="lg"
                    pill
                    block
                >
                    {{ $t("Start Verification") }}
                </b-btn>
                <a
                    v-else
                    target="_blank"
                    :href="url"
                    class="btn btn-primary btn-lg w-100 rounded-pill"
                >
                    {{ $t("Start Verification") }}
                </a>
            </div>
            <div v-else>
                <generic-loading />
            </div>
        </div>

        <onboarding-verification-link />
    </div>
</template>


<script>
import { mapState } from "vuex";

import OnboardingVerificationLink from "@/components/onboarding/verification/OnboardingVerificationLink";

export default {
    data() {
        return {
            url: null,
        };
    },
    created() {
        this.api.post("/sumsub/getVerificationUrl").then((response) => {
            this.url = response?.data?.url;
        });
    },
    computed: {
        ...mapState("system", ["cordova"]),
    },
    methods: {
        cordovaVerification() {
            this.$store.dispatch("system/openBrowser", this.url);
        },
    },
    components: {
        OnboardingVerificationLink,
    },
};
</script>